import React, { useState, useEffect } from "react";
import { I2cButton } from "@webcomponents/i2cwebcomponents/dist/react";
import Banner from "../../Components/Banner/Banner";
import ConcurrentTable from "../../Components/ConcurrentTable/ConcurrentTable";
import illustration from "../../assets/images/concurrent-session-banner.svg";
import illustrationDark from "../../assets/images/concurrent-session-banner-dmode.svg";
import ConcurrentSessionService from "../../Services/ConcurrentSession";
import { useNavigate } from "react-router-dom";
import { UserStateContext } from "../../Context/AuthContext";
import "./ConcurrentSession.scss";
import SecureFooter from "../../Components/SecureFooter/SecureFooter";
import { useQuery } from "react-query";
import AuthService from "../../Services/AuthServices";
import AlertMessage from "../../Components/SharedComponent/Alert/Alert"
/**
 * Component for managing concurrent sessions.
 * Displays concurrent sessions information and provides options to keep sessions alive or kill all sessions.
 * @returns JSX.Element
 */


/**
 * Component for managing concurrent sessions.
 * Displays concurrent sessions information and provides options to keep sessions alive, kill all sessions, or exit.
 * @returns JSX.Element
 */
const ConcurrentSession = () => {
  // State to manage loading states
  const [killAllloading, setKillAllLoading] = useState(false);
  const [keepAliveloading, setKeepAliveloading] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);
  // State for alert visibility
  const [showAlert, setShowAlert] = useState(false);
  // Context for user state
  const appContext = UserStateContext();
  // Navigation hook
  const navigate = useNavigate();

  // Fetch sessions data
  const queryKey = ["sessions"];
  const fetchSessions = async () => {
    const res = await ConcurrentSessionService.getSessions();
    return res.data.sessions;
  };

  const { data: sessions = [], isLoading } = useQuery(queryKey, fetchSessions, {
    refetchOnWindowFocus: false,
  });

  // Function to handle killing all sessions
  const handleAllSessionsKill = async () => {
    try {
      setKillAllLoading(true);
      const response = await ConcurrentSessionService.killAllSessions();
      setKillAllLoading(false);
      if (response.data.status) {
        appContext.setSessionCount(0);
        // Check for redirect URL from sessionStorage
        const redirectUrl = sessionStorage.getItem('redirectAfterLogin');
        if (redirectUrl) {
          sessionStorage.removeItem('redirectAfterLogin');
          navigate(redirectUrl);
        } else {
          navigate("/sales");
        }
      }
    } catch (error) {
      console.error("Error killing sessions:", error);
      setKillAllLoading(false);
    }
  };

  // Function to handle keeping sessions alive
  const handleKeepSessionsAlive = async () => {
    try {
      setKeepAliveloading(true);
      const response = await ConcurrentSessionService.keepSessionsAlive();
      setKeepAliveloading(false);
      if (response.data.status) {
        appContext.setSessionCount(0);
        // Check for redirect URL from sessionStorage
        const redirectUrl = sessionStorage.getItem('redirectAfterLogin');
        if (redirectUrl) {
          sessionStorage.removeItem('redirectAfterLogin');
          navigate(redirectUrl);
        } else {
          const userRole = appContext.userRole;
          const userRoleName = appContext.roleName;
          if (userRole === 5 || userRole === '5' || userRoleName === 'client') {
            navigate("/impl");
          } else {
            navigate("/sales");
          }
        }
      }
    } catch (error) {
      console.error("Error keeping sessions alive:", error);
      setKeepAliveloading(false);
    }
  };

  // Function to handle logout
  const handleLogout = () => {
    setLogoutLoading(true);
    AuthService.logout()
      .then((res) => {
        localStorage.removeItem("token");
        localStorage.removeItem("session");
        localStorage.removeItem("role");
        localStorage.removeItem("userRole");
        navigate("/login");
       
      })
      .catch((e) => {
        localStorage.removeItem("token");
        localStorage.removeItem("session");
        localStorage.removeItem("role");
        localStorage.removeItem("userRole");
        navigate("/login");
       
      })
      .finally(() => setLogoutLoading(false));
  };

  // Show alert when session length is 3
  useEffect(() => {
    if (sessions.length > 3 && !isLoading) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
  }, [sessions, isLoading]);

  return (
    <>
      <div className="concurrent-session-container">


        {/* Banner component */}
        <Banner
          bannerImage={appContext.darkMode ? illustrationDark : illustration}
          bannerTitle="Concurrent Session"
          bannerDescription={`You've already signed in using the same credentials. Please see the information below.${!showAlert ? " Kindly kill or stay alive to proceed." : ""
            }`}
        />


        {/* Concurrent table component */}
        <div className="concurrentTable__wrap">
          <div i2c-container="container xl">
            <AlertMessage
              open={showAlert}
              message="You're logged in on the maximum number of devices (3). Log out from one to continue."
              variant="danger"
              closable
              duration={Infinity}
            />
          </div>
          <ConcurrentTable />
        </div>
        {/* Button container */}
        <div
          className="btn-container-concurrent-session"
          i2c-container="container xl"
        >
          <div className="concurrent__btns">
            {/* Keep Alive button - only shown if sessions < 3 */}

            {sessions.length > 3 ? (
              <I2cButton
                size="medium"
                disabled={logoutLoading}
                variant="secondary gray"
                loading={logoutLoading}
                onClick={handleLogout}
              >
                Exit
              </I2cButton>
            ) : (
              <I2cButton
                size="medium"
                variant="secondary gray"
                disabled={keepAliveloading}
                loading={keepAliveloading}
                onClick={handleKeepSessionsAlive}
              >
                Keep Alive
              </I2cButton>
            )}
            {/* Kill All button */}
            <I2cButton
              size="medium"
              disabled={killAllloading}
              variant="primary"
              loading={killAllloading}
              onClick={handleAllSessionsKill}
            >
              Kill All
            </I2cButton>
            {/* Exit button - only shown when sessions = 3 */}

          </div>
        </div>
      </div>
      <SecureFooter containerClass="fixed-footer" />
    </>
  );
};

// const ConcurrentSessionReal = () => {
//   // State to manage loading state
//   const [killAllloading, setKillAllLoading] = useState(false);
//   const [keepAliveloading, setKeepAliveloading] = useState(false);
//   // Context for user state
//   const appContext = UserStateContext();

//   // Navigation hook
//   const navigate = useNavigate();

//   // Function to handle killing all sessions
//   // const handleAllSessionsKill = async () => {
//   //   // Set loading state
//   //   setKillAllLoading(true);
//   //   // Call API to kill all sessions
//   //   const response = await ConcurrentSessionService.killAllSessions();
//   //   // Reset loading state
//   //   setKillAllLoading(false);
//   //   // If successful response, update session count and navigate to dashboard
//   //   if (response.data.status) {
//   //     appContext.setSessionCount(0);
//   //     navigate("/sales");
//   //   }
//   // };
//   const handleAllSessionsKill = async () => {
//     try {
//       setKillAllLoading(true);
//       const response = await ConcurrentSessionService.killAllSessions();
//       setKillAllLoading(false);
//       if (response.data.status) {
//         appContext.setSessionCount(0);
//         navigate("/sales");
//       }
//     } catch (error) {
//       console.error("Error killing sessions:", error);
//       setKillAllLoading(false);
//     }
//   };
//   // Function to handle keeping sessions alive
//   // const handleKeepSessionsAlive = async () => {
//   //   // Set loading state
//   //   setKeepAliveloading(true);
//   //   // Call API to keep sessions alive
//   //   const response = await ConcurrentSessionService.keepSessionsAlive();
//   //   // Reset loading state
//   //   setKeepAliveloading(false);
//   //   // If successful response, update session count and navigate to dashboard
//   //   if (response.data.status) {
//   //     appContext.setSessionCount(0);

//   //     const userRole = appContext.userRole;
//   //     if (userRole === 5) {
//   //       navigate("/impl");
//   //     } else {
//   //       navigate("/sales");
//   //     }
//   //   }
//   // };
//   const handleKeepSessionsAlive = async () => {
//     try {
//       setKeepAliveloading(true);
//       const response = await ConcurrentSessionService.keepSessionsAlive();
//       setKeepAliveloading(false);
//       if (response.data.status) {
//         appContext.setSessionCount(0);
//         const userRole = appContext.userRole;
//         if (userRole === 5) {
//           navigate("/impl");
//         } else {
//           navigate("/sales");
//         }
//       }
//     } catch (error) {
//       console.error("Error keeping sessions alive:", error);
//       setKeepAliveloading(false);
//     }
//   };
//   return (
//     <>
//       <div className="concurrent-session-container">
//         {/* Banner component */}
//         <Banner
//           bannerImage={appContext.darkMode ? illustrationDark : illustration}
//           bannerTitle="Concurrent Session"
//           bannerDescription="You've already signed in using the same credentials. Please see the information below. Kindly kill or stay alive to proceed."
//         />
//         {/* Concurrent table component */}
//         <div className="concurrentTable__wrap">
//           <ConcurrentTable />
//         </div>
//         {/* Button container */}
//         <div
//           className="btn-container-concurrent-session"
//           i2c-container="container xl"
//         >
//           <div className="concurrent__btns">
//             {/* Keep Alive button */}
//             <I2cButton
//               size="medium"
//               variant="secondary gray"
//               disabled={keepAliveloading}
//               loading={keepAliveloading}
//               onClick={handleKeepSessionsAlive}
//             >
//               Keep Alive
//             </I2cButton>
//             {/* Kill All button */}
//             <I2cButton
//               size="medium"
//               disabled={killAllloading}
//               variant="primary"
//               loading={killAllloading}
//               onClick={handleAllSessionsKill}
//             >
//               Kill All
//             </I2cButton>
//           </div>
//         </div>
//       </div>
//       <SecureFooter containerClass="fixed-footer" />
//     </>
//   );
// };

export default ConcurrentSession;
